/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */

import api, {
  multiPartHeader, 
  partHeader, 
  apiInternal, 
  apiTraining
 } from '../../api.js';
import { formatStringDate, dateBeforeNow} from '../../misc/utils';

const state = {
  all: [],
  offers: [],
  needs: [],
  usages: [],
  documents: [],
  statsTraining: [],
};

const getters = {
  contractById: state => id => state.all.find(contract => contract.cont_id === id),
  contractsToCheck: (state) => {
    return state.all.filter(c => (c.cont_date_end == null && dateBeforeNow(c.cont_check_date))); // moment(c.cont_check_date).isBefore(moment())));
  },
};

const actions = {
  async getAllContracts({ commit }) {
    const result = await api.post(`${apiInternal}/getContracts`,{},partHeader);
    if (result) commit('setContracts', result.data);
    return result;
  },
  async getAllOffers({ commit }) {
     const result = await api.post(`${apiInternal}/getOffers`,{},partHeader);
      if (result) commit('setOffers', result.data);
      return result;
  },
  async getAllNeeds({ commit }) {
    const result = await api.post(`${apiTraining}/getNeeds`,{},partHeader);
      if (result) commit('setNeeds', result.data);
      return result;
  },
  async getAllTrainingDocuments({ commit }) {
    const result = await api.post(`${apiInternal}/getTrainingDocuments`,{},partHeader);
      if (result) commit('setTrainingDocuments', result.data);
      return result;
  },
  async getStatsTraining({ commit }) {
    const result = await api.post(`${apiInternal}/GetTrainingStats`,{},partHeader);
      if (result) commit('setTrainingStats', result.data);
      return result;
  },
  async setNeed({ commit }, params) {
    const result = await api.post(`${apiInternal}/setNeed`, params,partHeader);
    if (result) commit('setNeeds', result.data);
    return result;
  },
  async deleteusage({ commit }, params) {
    const result = await api.post(`${apiInternal}/deleteUsage`, params,partHeader);
    if (result) commit('setUsages', result.data);
    return result;
  },
  async deleteneed({ commit }, params) {
    const result = await api.post(`${apiInternal}/deleteNeed`, params,partHeader);
    if (result) commit('setNeeds', result.data);
    return result;
  },
  async setContractEnd({ commit }, params) {
    const result = await api.post(`${apiInternal}/setContractEnd`, params, partHeader);
    return result;
  },
  async getAllUsages({ commit }) {
    const result = await api.post(`${apiTraining}/getUsages`,{},partHeader );
    if (result) commit('setUsages', result.data);
    return result;
  },
  async setUsage({ commit }, params) {
    const result = await api.post(`${apiInternal}/setUsage`, {},partHeader);
    if (result) commit('setUsages', result.data);
    return result;
  },
  async importTrainingDocument({ commit }, formList) {
    const result = await api.post(`${apiInternal}/importTrainingDocument`, formList, multiPartHeader);
    return result;
  },
  async getContractById({ commit }, contId) {
    const result = await api.post(`${apiInternal}/getContract`, { cont_id: contId },partHeader);
    if (result) commit('updateContract', result.data);
    return result;
  },
  async addContract({ commit }, contract) {
    const result = await api.post(`${apiInternal}/setContract`, contract ,partHeader);
    if (result) commit('addContract', result.data);
    return result;
  },
  async removeEstablishments({  commit }, params) {
    const result = await api.post(`${apiInternal}/dissociateEstablishmentsFromContract`, params,partHeader);
    return result;    
  },
  async setEstablishments({ commit }, params) {
    const result = await api.post(`${apiInternal}/setEstablishmentsToContract`, params,partHeader);
    return result;    
  },
};

const mutations = {
  setContracts(state, contracts) {
    state.all = contracts;
    state.all.forEach((contract) => {
      contract.cont_date_start = formatStringDate(contract.cont_date_start) //= moment(contract.cont_date_start).format('DD/MM/YYYY');
      if (contract.cont_date_end != null) {
        contract.cont_date_end = formatStringDate(contract.cont_date_end) //= moment(contract.cont_date_end).format('DD/MM/YYYY');
      }
    });
  },
  setOffers(state, offers) {
    state.offers = offers;
  },
  setNeeds(state, needs) {
    state.needs = needs;
  },
  setUsages(state, usages) {
    state.usages = usages;
  },
  setTrainingDocuments(state, documents) {
    state.documents = documents;
  },
  setTrainingStats(state, statsTraining) {
    state.statsTraining = statsTraining;
  },
  addContract(state, contract) {
    contract.cont_date_start = formatStringDate(contract.cont_date_start) //moment(contract.cont_date_start).format('DD/MM/YYYY');
    if (contract.cont_date_end != null) {
      contract.cont_date_end = formatStringDate(contract.cont_date_end) //= moment(contract.cont_date_end).format('DD/MM/YYYY');
    }
    state.all.push(contract);
  },
  updateContract(state, newContract) {
    const index = state.all.findIndex(contract => contract.cont_id === newContract.cont_id);
    newContract.cont_date_start = formatStringDate(newContract.cont_date_start) //= moment(newContract.cont_date_start).format('DD/MM/YYYY');
    if (newContract.cont_date_end != null) {
      newContract.cont_date_end = formatStringDate(newContract.cont_date_end) //moment(newContract.cont_date_end).format('DD/MM/YYYY');
    }
    if (index >= 0) {
      state.all.splice(index, 1, newContract);
    } else {
      state.all.push(newContract);
    }
    // TODO : set date properly
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
